import React, { Component } from "react";
import { Container,} from "reactstrap";
import { NavLink } from "react-router-dom";

class MainPage extends Component {
  constructor(props){
    super(props)
    this.getCurrentLink = this.getCurrentLink.bind(this)
    
}

componentDidMount() {
  this.getCurrentLink();
}


getCurrentLink(){

  //  get current page through the route
    const subDirectories=["hebergement","vols","visas","voyages","cars","divertissements"]
    for (let i = 0; i < subDirectories.length; i++) {
      const elm = subDirectories[i];
      const currentLink = window.location.href
      const subPath = currentLink.search(elm)
       if(subPath>0){
         document.getElementById(elm).classList.add('active')
        }
          
    }
}

  render() {
    return (
      <>
        <section className='navigation text-center d-none d-md-block'>
          <Container>
            <h1 className="py-5 color-gh font-weight-bold">Parcourire les announces</h1>
          {/* <img src="/imgs/logo/Group_83.svg" alt="logo" className="logo-navTab" style={{display:this.props.display}}/> */}
            <ul className='list-unstyled row list-inline ' >
              <NavLink to='/hebergement' className=' px-0 col-2 '>
                <li  id="hebergement" className='list-inline-item  ' >
                  <img src="/imgs/home/navtab_heberg.svg" alt="" />
                    <span className="pt-2 d-block">
                        Hebergements
                    </span>
                </li>
              </NavLink>

              <NavLink to='/vols' className=' px-0 col-2' >
              

              <li id="vols" className='list-inline-item  '>
              <img src="/imgs/home/navtab_vol.svg" alt="" />
              <span className="pt-2 d-block">
                  Vols
                </span>
              
              </li>
              </NavLink>


              <NavLink to='/visas' className=' px-0 col-2 '>
              <li id="visas" className='list-inline-item  '>
              <img src="/imgs/home/navtab_visa.svg" alt="" />
              <span className="pt-2 d-block">
                  Visa
                </span>
              </li>
              </NavLink>

              <NavLink to='/voyages' className=' px-0 col-2'>

              <li id="voyages" className='list-inline-item  '>
              <img src="/imgs/home/navtab_voyage.svg" alt="" />
              <span className="pt-2 d-block">
                Voyages
              </span>

              </li>
              </NavLink>
                <NavLink to='/cars' className=' px-0 col-2'>

              <li id="cars" className='list-inline-item  '>
              <img src="/imgs/home/navtab_vehicule.svg"   alt="" />
              <span className="pt-2 d-block">
                  Véhicule
                </span>

              </li>
                </NavLink>

              <NavLink to='/divertissements' className=' px-0 col-2'>

              <li id="divertissements" className='list-inline-item  '>
              <img src="/imgs/home/navtab_divert.svg" className="" alt="" />
              <span className="pt-2 d-block">
                  Divertissements

                </span>

              </li>
              </NavLink>

            </ul>
            {/* {!this.props.under &&(<hr />)} */}
          </Container>
        </section>
      </>
    );
  }
}

export default MainPage;
